import React from 'react';
import { Route, Redirect } from 'react-router-dom';
const PrivateRoute = ({ component: Component, isAuthenticated, ...children }) => {
  return <Route {...children} render={props => (isAuthenticated.token ? <Component {...props} /> : <Redirect to="/login" />)} />;

};
export default PrivateRoute;
